angular.module('leanlaw').directive('llDateRangeSelect', ['$compile', '$http', 'alerts', function ($compile, $http, alerts) {
  function monthString(month) {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month];
  }
  return {
    restrict: 'A',
    scope: {
      range: '=ngModel',
      rangeOnlyMonthly: '=',
      rangeTitle: '=',
      rangeUpToToday: '=',
      rangeHideTitle: '=',
      defaultRange: '@',
      horizontal: '='
    },
    template: require('./views/dateRangeSelect.html'),
    controller: ['$scope', function ($scope) {
      $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 0,
        showWeeks: false,
        showButtonBar: false
      };
      var today = new Date();
      var endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      var previousMonthString = monthString(endOfPreviousMonth.getMonth()) + " " + endOfPreviousMonth.getFullYear();
      var startOfThisWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
      var endOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 7);
      var startOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
      $scope.changeStart = function () {
        $scope.range.label = null;
        if ($scope.range.startDate && $scope.range.endDate && $scope.range.startDate > $scope.range.endDate) {
          $scope.range.endDate = $scope.range.startDate;
        }
      };
      $scope.changeEnd = function () {
        $scope.range.label = null;
        if ($scope.range.startDate && $scope.range.endDate && $scope.range.startDate > $scope.range.endDate) {
          $scope.range.startDate = $scope.range.enddate;
        }
      };
      $scope.periods = [{
        label: "All Time",
        range: {
          startDate: null,
          //new Date(today.getFullYear() - 2, 0, 1),
          endDate: null
        }
      }, {
        label: "Up to Today",
        range: {
          startDate: null,
          endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
        }
      }, {
        label: "This Year",
        range: {
          startDate: new Date(today.getFullYear(), 0, 1),
          endDate: new Date(today.getFullYear(), 11, 31)
        }
      }, {
        label: "Last Year",
        range: {
          startDate: new Date(today.getFullYear() - 1, 0, 1),
          endDate: new Date(today.getFullYear() - 1, 11, 31)
        }
      }, {
        label: previousMonthString + " and earlier",
        range: {
          startDate: null,
          //new Date(today.getFullYear() - 2, 0, 1),
          endDate: endOfPreviousMonth
        }
      }, {
        id: 'lastMonth',
        label: previousMonthString,
        range: {
          startDate: new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth(), 1),
          endDate: endOfPreviousMonth
        }
      }, {
        label: "This Month",
        range: {
          startDate: new Date(today.getFullYear(), today.getMonth(), 1),
          endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        }
      }];
      if (!$scope.rangeOnlyMonthly) {
        $scope.periods.push({
          label: "This Week",
          range: {
            startDate: startOfThisWeek,
            endDate: endOfWeek
          }
        });
        $scope.periods.push({
          label: "Last Week",
          range: {
            startDate: startOfLastWeek,
            endDate: startOfThisWeek
          }
        });
        $scope.periods.push({
          label: "Today",
          range: {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
          }
        });
      }
      $scope.periods.push({
        label: "Custom Period",
        custom: true
      });
      const defaultPeriod = $scope.rangeUpToToday ? $scope.periods.find(p => p.label === "Up to Today") : $scope.periods[0];
      $scope.change = function () {
        if (!$scope.period) {
          $scope.period = _.find($scope.periods, p => p.label == $scope.defaultRange) || defaultPeriod;
        }
        if ($scope.period.custom) {
          //$scope.range = null;
          $scope.range.label = $scope.period.label;
        } else {
          $scope.range = angular.copy($scope.period.range);
          $scope.range.label = $scope.period.label;
        }
        if ($scope.rangeUpToToday && $scope.period?.label === 'All Time') {
          alerts.warning("Using 'All Time' can unintentionally include future billable items such as recurring fixed fees. ");
        }
      };
      $scope.period = defaultPeriod;
      if ($scope.defaultRange) {
        $scope.period = _.find($scope.periods, p => p.label == $scope.defaultRange || p.id == $scope.defaultRange) || defaultPeriod;
      } else if ($scope.range && $scope.range.label) {
        $scope.period = _.find($scope.periods, p => p.label == $scope.range.label);
      } else if ($scope.range && ($scope.range.startDate || $scope.range.endDate)) {
        $scope.period = _.find($scope.periods, p => p.custom);
      }
      $scope.change();
    }]
  };
}]);